<template>
  <ModalConfirmAction
    rootClass="ModalDeleteWebsite"
    :isOpen="isOpen"
    :isLoading="isLoading"
    title="Delete webpage"
    lead="This will permanently remove the webpage and disable its shared link."
    bannerTheme="neutral"
    bannerIcon="trashRegular"
    bannerTitle="This action cannot be undone."
    bannerDescription="The webpage and its files will be permanently removed."
    confirmLabel="Delete"
    confirmTheme="error"
    @close="emit('close')"
    @confirm="emit('confirm')"
  />
</template>

<script lang="ts" setup>
import ModalConfirmAction from '@/views/components/modals/ModalConfirmAction.vue'

// Delete is irreversible. The banner stays neutral (grey) — the red confirm button
// carries the destructive signal, so no warning tint is needed.
defineProps<{
  isOpen: boolean
  isLoading?: boolean
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()
</script>
